export default __webpack_public_path__ + "static/media/Teachersday1.f5dae11f.JPG";